import React, {useContext, useEffect, useState} from "react"

import Button from "../../../../common/Button";
import {api} from "../../../../../api/api";
import {getErrorByStatus} from "../../helpers";
import InsertField from "../../../../common/InsertField"
import TranslationContext from "../../../../../context/TranslationContext";
import UserContext from "../../../../../context/UserContext";

const PinAction = ({handlerBackBtn, setAccess}) => {
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)
    const [pin, setPin] = useState("")
    const [error, setError] = useState("")
    const [errMessage, setErrMessage] = useState("")

    const pinInputHandler = (evt) => {
        setPin(v => {
            return evt.target.validity.valid
                ? evt.target.value
                : v
        })
    }

    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrMessage(getTranslation(error))} else {setErrMessage(error)}  
        }
    },[getTranslation, error])

    const pinOtpHandler = () => {
        if (pin === "") {
            setError("no_pin")
        } else {
            setApiWait(true)
            api.getPinCheck(pin).then(res => {
                if (res.status === 200) {
                    setAccess(true)
                } else {
                    setError("err_int")
                }
            }).catch(err => {
                if (err.response.status===400) {
                    setError("wrong_pin")
                    return
                } 
                getErrorByStatus(err.response.status, setError, getTranslation)
            }).finally(() => setApiWait(false))
        }
    }

    return (
        <>
            <span data-id_phrase="no_pin">{getTranslation("no_pin")}</span>
            <InsertField
                type="text"
                value={pin}
                onChange={pinInputHandler}
                placeholder="XXXXXXXXXX"
                pattern='[0-9]*'
            />
            {
                error && <p className="error" data-id_phrase={error}>{errMessage}</p>
            }
            <Button onClick={pinOtpHandler} idPhrase={"btn_acc"}/>
            <Button onClick={() => handlerBackBtn()} idPhrase={"back"}/>
        </>
    )
}

export default PinAction